import { render, staticRenderFns } from "./TemplateManager.vue?vue&type=template&id=1d9ff238&"
import script from "./TemplateManager.vue?vue&type=script&lang=js&"
export * from "./TemplateManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports